/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-use-before-define: 0, no-var: 0 */
/* globals _ */

/**
 *  This file contains global chart configs.
 *
 *  The current chart configs are:
 *   - 'default_chart'
 *   - 'clean_chart'
 *
 */

_.namespace(`mp.charts.options`, function(ns) {
  'use strict';

  function draw_axis_bgs() {
    /*jshint validthis: true */
    var r = this.renderer,
      corner_radius = 6,
      chart_options = this.options.chart,
      y_width = this.chartWidth - this.plotWidth - (chart_options.spacingLeft || (chart_options.spacing && chart_options.spacing[3]) || 0),
      y_height = this.plotHeight + (chart_options.marginTop || (chart_options.margin && chart_options.margin[0]) || 0);

    // draw plot bg
    // -5px vertical offset is to hide the top border
    var maxBackgroundWidth = 1640;
    r.rect(0, -5, this.chartWidth, y_height + 5, 5).attr({
      'stroke-width': 1,
      'stroke': `#b2b6c0`,
      'fill': `#ffffff`,
      'width': maxBackgroundWidth,
      'zIndex': 0,
    }).add();

    // draw y-axis bg
    r.rect(1, 0, y_width - 10, y_height - 2, corner_radius).attr({
      'stroke-width': 0,
      'fill': `#fbfcfd`,
      'zIndex': 0,
    }).add();
    var y_axis = r.crispLine([`M`, y_width - 10, 0, `L`, y_width - 10, y_height-1], 1);
    r.path(y_axis).attr({'stroke': `#d3dfe7`, 'stroke-width': 1, 'zIndex': 1}).add();
    _.bind(kill_last_gridline, this)();
  }

  // this function is a hack because highcharts insists on showing a
  // gridline for the 0th label on the y-axis, which conflicts with
  // the x-axis
  function kill_last_gridline() {
    /*jshint validthis: true */
    var gridlines = $(`.highcharts-grid path`, this.container).show(),
      line = _(gridlines).chain()
        .map(function(gridline) {
          var $gridline = $(gridline);
          return [$gridline, $gridline.offset().top];
        })
        .sortBy(function(gridline) { return gridline[1]; })
        .last()
        .value();

    if (line) { line[0].hide(); }
  }

  ns.default_chart = {
    'chart': {
      'height': 400, // this is needed to prevent autosizing from the padding-bottom so border-radius doesn't get cut off
      'zoomType': `x`,
      'marginTop': 0,
      'marginLeft': 62,
      'marginBottom': 30,
      'events': {
        'load': draw_axis_bgs,
        'redraw': kill_last_gridline,
      },
      'backgroundColor': `rgba(255,255,255,0)`,
      'style': {
        'fontFamily': `"Helvetica Neue", helvetica, sans-serif`,
        'fontSize': `12px`,
      },
    },
    'credits': {'enabled': false},
    'legend': {'enabled': false},
    'loading': {
      'labelStyle': {'color': `transparent`},
    },
    'plotOptions': {
      'line': {
        'turboThreshold': 0,
        'shadow': false,
        'lineWidth': 1,
        'marker': {
          'symbol': `circle`,
          'lineWidth': 2,
          'lineColor': `#fff`,
          'radius': 5,
        },
        'incompleteStyle': {'stroke-dasharray': `3,5`},
      },
      'column': {
        'stacking': `normal`,
        'groupPadding': 0.1,
        'shadow': false,
        'borderWidth': 0,
      },
    },
    'tooltip': {
      'backgroundColor': `rgba(255, 255, 255, 0)`,
      'borderWidth': 0,
      'shadow': false,
      'useHTML': true,
    },
    'title': {'text': null},
    'xAxis': {
      'dateTimeLabelFormats': {
        'day': `%b %e`,
      },
      'labels': {
        'y': 18,
        'style': {
          'color': `#868ea3`,
        },
      },
      'lineColor': `#c0c0c0`,
      'lineWidth': 0,
      'tickmarkPlacement': `on`,
      'tickPosition': `outside`,
    },
    'yAxis': {
      'allowDecimals': true,
      'gridLineColor': `#e6e8eb`,
      'gridLineDashStyle': `shortDash`,
      'lineWidth': 0,
      'endOnTick': false,
      'labels': {
        'x': -20,
        'style': {
          'fontWeight': `bold`,
          'color': `#868ea3`,
        },
      },
      'min': 0,
      'minPadding': 0,
      'showFirstLabel': false,
      'title': {'text': null},
    },
  };

  ns.clean_chart = {
    'chart': {
      'borderWidth': 0,
      'shadow': false,
      'height': 400, // this is needed to prevent autosizing from the padding-bottom so border-radius doesn't get cut off
      'zoomType': `x`,
      'marginTop': 20,
      'marginLeft': 62,
      'marginRight': 10,
      'marginBottom': 30,
      'events': {
        'load': kill_last_gridline,
        'redraw': kill_last_gridline,
      },
      'backgroundColor': `rgba(255,255,255,0)`,
      'style': {
        'fontFamily': `"Helvetica Neue", helvetica, sans-serif`,
        'fontSize': `12px`,
      },
    },
    'credits': {'enabled': false},
    'legend': {'enabled': false},
    'loading': {
      'labelStyle': {'color': `transparent`},
    },
    'plotOptions': {
      'line': {
        'turboThreshold': 0,
        'shadow': false,
        'lineWidth': 1,
        'marker': {
          'symbol': `circle`,
          'lineWidth': 2,
          'lineColor': `#fff`,
          'radius': 5,
        },
        'incompleteStyle': {'stroke-dasharray': `3,5`},
      },
      'column': {
        'stacking': `normal`,
        'groupPadding': 0.1,
        'shadow': false,
        'borderWidth': 0,
      },
      'series': {
        'animation': {
          'duration': 300,
        },
      },
    },
    'tooltip': {
      'backgroundColor': `rgba(255, 255, 255, 0)`,
      'borderWidth': 0,
      'shadow': false,
      'useHTML': true,
    },
    'title': {'text': null},
    'xAxis': {
      'dateTimeLabelFormats': {
        'day': `%b %e`,
      },
      'labels': {
        'y': 18,
        'style': {
          'color': `#868ea3`,
        },
      },
      'lineColor': `#c0c0c0`,
      'lineWidth': 0,
      'tickmarkPlacement': `on`,
      'tickPosition': `outside`,
    },
    'yAxis': {
      'allowDecimals': true,
      'gridLineColor': `#e6e8eb`,
      'gridLineDashStyle': `shortDash`,
      'lineWidth': 0,
      'endOnTick': false,
      'labels': {
        'x': -20,
        'style': {
          'fontWeight': `bold`,
          'color': `#868ea3`,
        },
      },
      'min': 0,
      'minPadding': 0,
      'showFirstLabel': false,
      'title': {'text': null},
      'plotLines': [{
        'value': 0,
        'width': 1,
        'color': `#c0d0e0`,
      }],
    },
    'global': {
      'useUTC': false,
    },

  };

});

}.call(window));